import { render, staticRenderFns } from "./VehicleColor.vue?vue&type=template&id=4ddbd405&"
import script from "./VehicleColor.vue?vue&type=script&lang=js&"
export * from "./VehicleColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports